import type { RouteRecordRaw } from "vue-router";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION } from "~/modules/globalDeviceConfiguration/constants";
import GlobalDeviceConfigurationPage from "~/modules/globalDeviceConfiguration/views/GlobalDeviceConfigurationPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION,
    component: GlobalDeviceConfigurationPage,
    meta: {
      breadcrumb: BREADCRUMBS.GLOBAL_DEVICE_CONFIGURATION,
    },
  },
];

export default routes;
